export enum DrawingTypeId {
  MONATSAUSLOSUNG = 1,
  JAHRESAUSLOSUNG = 2,
  SONDERAUSLOSUNG = 3,
  MONATS_UND_SONDERAUSLOSUNG = 4,
  MONATS_AUSLOSUNG = 5,
  SONDER_AUSLOSUNG = 6,
  DANKE_AUSLOSUNG = 7,
  SACHPREISAUSLOSUNG = 8,
  MONATS_UND_JAHRESAUSLOSUNG = 9,
}

export const DrawingTypeLabel: Record<DrawingTypeId, string> = {
  [DrawingTypeId.MONATSAUSLOSUNG]: 'Monatsauslosung',
  [DrawingTypeId.JAHRESAUSLOSUNG]: 'Jahresauslosung',
  [DrawingTypeId.SONDERAUSLOSUNG]: 'Sonderauslosung',
  [DrawingTypeId.MONATS_UND_SONDERAUSLOSUNG]: 'Monats- und Sonderauslosung',
  [DrawingTypeId.MONATS_AUSLOSUNG]: 'Monats-Auslosung',
  [DrawingTypeId.SONDER_AUSLOSUNG]: 'Sonder-Auslosung',
  [DrawingTypeId.DANKE_AUSLOSUNG]: 'DANKE-Auslosung',
  [DrawingTypeId.SACHPREISAUSLOSUNG]: 'Sachpreisauslosung',
  [DrawingTypeId.MONATS_UND_JAHRESAUSLOSUNG]: 'Monats- und Jahresauslosung',
};
